import { Mapping } from "../../types/mapping";

/**
 * Single source of truth for the five mediation engines a `Mapping` carries dependency
 * fields for, and the corresponding `engine` value used to scope `v4/spm` rows.
 *
 * - `key` matches the camelCase prefix of the per-engine `Mapping` fields
 *   (`<key>DependencyIos` / `<key>DependencyAndroid`).
 * - `engine` matches the backend's `SpmInfoService.KNOWN_ENGINES` values exactly
 *   (`appodeal | max | levelplay | bidmachine | bidon` — note `levelplay` has no separator,
 *   unlike the `levelPlay` field-name key).
 */
export interface MediationEngineDef {
  key: string;
  label: string;
  engine: string;
}

export const MEDIATION_ENGINES: MediationEngineDef[] = [
  { key: "appodeal", label: "Appodeal", engine: "appodeal" },
  { key: "max", label: "AppLovin MAX", engine: "max" },
  { key: "levelPlay", label: "LevelPlay (IronSource)", engine: "levelplay" },
  { key: "bidmachine", label: "BidMachine", engine: "bidmachine" },
  { key: "bidon", label: "Bidon", engine: "bidon" },
];

export interface EngineDependencyFields {
  ios?: string;
  android?: string;
}

export const engineDependencyFieldNames = (
  key: string
): { ios: keyof Mapping; android: keyof Mapping } => ({
  ios: `${key}DependencyIos` as keyof Mapping,
  android: `${key}DependencyAndroid` as keyof Mapping,
});

export const engineDeps = (
  mapping: Mapping | undefined,
  key: string
): EngineDependencyFields => {
  if (!mapping) return {};
  const { ios, android } = engineDependencyFieldNames(key);
  return {
    ios: mapping[ios] as string | undefined,
    android: mapping[android] as string | undefined,
  };
};
